import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconButton } from 'seagull';
import { Trash } from 'seagull/icons';
import TimeActivityTooltip from '../../TimeActivityTooltip/TimeActivityTooltip';
import { BillingType } from '../BillClientModal.types';
export function BillClientTableAction(param) {
    let { item, itemIndex, showDeleteButton, timeActivities, allowTimeActivities, onDeleteItem } = param;
    const timeActivity = item.type === BillingType.Service ? timeActivities.getTimeActivitiesForService(item.service.id).find((ta)=>ta.id === item.timeActivityId) : undefined;
    return /*#__PURE__*/ _jsxs("div", {
        style: {
            display: 'flex',
            alignItems: 'center'
        },
        children: [
            allowTimeActivities && timeActivity && /*#__PURE__*/ _jsx(TimeActivityTooltip, {
                timeActivity: timeActivity
            }),
            showDeleteButton && /*#__PURE__*/ _jsx(IconButton, {
                onClick: ()=>onDeleteItem(itemIndex),
                testId: item.type === BillingType.Service ? "bill-service-".concat(itemIndex, "-delete-button") : "add-charge-".concat(itemIndex, "-delete-button"),
                children: /*#__PURE__*/ _jsx(Trash, {
                    size: 20
                })
            })
        ]
    });
}
